import {createApi} from "unsplash-js";

export const unsplash = createApi({
    accessKey: "XeKjFx84fJMjD9HQv4B8cQs2bDYgHcG_NjHIpoB5FIQ"
})